module.exports = __webpack_public_path__ + "img/img15.921348ad.png";